export default __webpack_public_path__ + "static/media/ShwetaKhatri.8999c090.jpg";